import { render, staticRenderFns } from "./CreateRateGroupModal.vue?vue&type=template&id=0395481a&scoped=true&"
import script from "./CreateRateGroupModal.vue?vue&type=script&lang=js&"
export * from "./CreateRateGroupModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateRateGroupModal.vue?vue&type=style&index=0&id=0395481a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0395481a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Kevin\\Documents\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0395481a')) {
      api.createRecord('0395481a', component.options)
    } else {
      api.reload('0395481a', component.options)
    }
    module.hot.accept("./CreateRateGroupModal.vue?vue&type=template&id=0395481a&scoped=true&", function () {
      api.rerender('0395481a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/TeamSettings/RateGroups/CreateRateGroupModal.vue"
export default component.exports